import {
  formatTimeLabel,
  formatTimeRangeLabel,
} from "web-apps/company/utils/timeAndDate";

/**
 * Resolve stamped time range for display.
 * Returns null when no stamped values exist.
 */
export const resolveStampedTimeRangeValue = (
  stampedStart: string | null,
  stampedEnd: string | null,
  locale: string,
): string | null => {
  if (stampedStart == null && stampedEnd == null) {
    return null;
  }

  if (stampedStart != null && stampedEnd != null) {
    return formatTimeRangeLabel(stampedStart, stampedEnd, locale);
  }

  if (stampedStart != null) {
    return `${formatTimeLabel(stampedStart, locale)} -`;
  }

  return `- ${formatTimeLabel(stampedEnd, locale)}`;
};
